import { authLayout } from "../helpers/withAuth";

export const platformRoutes = {
  path: "platforms",
  ...authLayout("Platforms", [
    {
      path: "/platforms/global",
      lazy: () =>
        import("../../modules/platforms/global").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/imdb",
      lazy: () =>
        import("../../modules/platforms/imdb").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/wikipedia",
      lazy: () =>
        import("../../modules/platforms/wikipedia").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/google",
      lazy: () =>
        import("../../modules/platforms/google").then((m) => ({
          Component: m.GoogleDashboard,
        })),
    },
    {
      path: "/platforms/rottentomatoes",
      lazy: () =>
        import("../../modules/platforms/rottenTomatoes").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/twitch",
      lazy: () =>
        import("../../modules/platforms/twitch").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/steam",
      lazy: () =>
        import("../../modules/platforms/steam").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/piracy",
      lazy: () =>
        import("../../modules/platforms/piracy").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/youtube",
      lazy: () =>
        import("../../modules/platforms/youtube").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/wikipedia/summary",
      lazy: () =>
        import("../../modules/wikipedia").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/wikipedia/raw-data",
      lazy: () =>
        import("../../modules/wikipedia/raw-data").then((m) => ({
          Component: m.RawDataPage,
        })),
    },
    {
      path: "/platforms/googletrends",
      lazy: () =>
        import("../../modules/googletrendsv2").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/google/raw-data",
      lazy: () =>
        import(
          "../../modules/google-trends/google-trends-raw-data-page"
        ).then((m) => ({ Component: m.GoogleTrendsRawDataPage })),
    },
    {
      path: "/platforms/ao3",
      lazy: () =>
        import("../../modules/platforms/ao3").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/wattpad",
      lazy: () =>
        import("../../modules/platforms/wattpad").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/reddit",
      lazy: () =>
        import("../../modules/platforms/reddit").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/twitter",
      lazy: () =>
        import("../../modules/platforms/twitter").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/fandom",
      lazy: () =>
        import("../../modules/platforms/fandom").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/tiktok",
      lazy: () =>
        import("../../modules/platforms/tiktok").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/amazonbooks",
      lazy: () =>
        import("../../modules/platforms/amazonbooks").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/barnesnoble",
      lazy: () =>
        import("../../modules/platforms/barnesnoble").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/fablebooks",
      lazy: () =>
        import("../../modules/platforms/fablebooks").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/goodreads",
      lazy: () =>
        import("../../modules/platforms/goodreads").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/storygraph",
      lazy: () =>
        import("../../modules/platforms/storygraph").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/myanimelist",
      lazy: () =>
        import("../../modules/platforms/myanimelist").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/anilist",
      lazy: () =>
        import("../../modules/platforms/anilist").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/platforms/consumer-products/amazon-search",
      lazy: () =>
        import("../../modules/consumer-products/amazon-vendor-central").then(
          (m) => ({ Component: m.AmazonVendorCentralPage }),
        ),
    },
  ]),
};
